<template>
  <f7-page name="about">
    <f7-navbar title="About" back-link="Back"></f7-navbar>

    <f7-block>
      <h2>About Wuju</h2>
      <p>
        A friend dragged me to a Sedona Method introduction class one night about 10 years ago. It was a pretty powerful
        experience (and my introduction to mindfullness in general), but it didn't stick and I moved on to other ways to find happiness.
        A decade later, now married, with a kid, in a different country and a completely different set of emotional issues, I stumbled upon the method again, this time in the form of
        Hale Dwoskin's book, <a href="https://www.amazon.com/Sedona-Method-Hale-Dwoskin-ebook/dp/B0050KEG64" target="_blank" class="external">The Sedona Method</a>.
      </p>
      <p>
        Working through the book and the method this time around, I found it very helpful to do the exercises in writing. As I was writing the seminal question
        "Would you let it go?" (which this app is named after) for the umpteenth time, it dawned on me how straight forward and linear this method was and how easy it would be to make an
        app out of it. This was in 2018. Wuju has evolved quite a bit since then, but the core idea of identifying and processing our emotions as a way to greater mental health and wellbeing remains.
      </p>
      <p>
        I can't claim it works for everyone, but using this app has been pretty revolutionary for me. I've struggled with depression in its various forms for
        most of my adult life and I tried everything from meditation to therapy to medication with limited results. This app is the best way I found to consistently get
        me out of my funk and stop the spiral of negative thoughts. My life and the lives of everyone around me is better because of it.
      </p>
      <p>
        Hope this works work you, as much as it does for me.
      </p>
      <img src="/static/img/eli.jpg">
      <p>
        Eli Finer<br class="normal">
        <a class="external" href="mailto:eli@wuju.app" target="_blank">eli@wuju.app</a>
      </p>
    </f7-block>
    <f7-block>
      <h2>Credits</h2>
      <h4>Music</h4>
      <ul>
        <li><a href="https://soothingrelaxation.com/products/d1lh55n72u0?_pos=244&_sid=2bcba26d6&_ss=r">Sunny Mornings</a> by Peder B. Helland</li>
      </ul>
      <h4>Technology</h4>
      <ul>
        <li><a href="https://framework7.io/">Framework 7</a></li>
      </ul>
      <h4>Photography</h4>
      <div>(via <a href="https://unsplash.com">Unsplash</a>)</div>
      <ul>
        <li v-for="photo in photos" :key="photo.path">
          <a class="external" target="_blank" :href="photo.link">{{photo.author}}</a>
        </li>
      </ul>
    </f7-block>
  </f7-page>
</template>

<style scoped>
.thumbnail {
    width: 50px;
    height: 50px;
    background-size: cover;
    background-position: center;
}
</style>

<script>
  import moment from 'moment';
  import Utils from '../js/utils.js';

  export default {
    computed: {
      photos() {
        return process.env.UNSPLASH.map((v) => { return {
          path: v.replace(/^src/, ''),
          author: Utils.capitalize(v.replace(/^.+\//, '').replace('-unsplash.jpg', '').slice(0, -12).replace('-', ' ')),
          link: 'https://unsplash.com/photos/'+v.replace(/^.+\//, '').replace('-unsplash.jpg', '').slice(-11),
        }});
      },
    },
  }
</script>